// extracted by mini-css-extract-plugin
export var about = "styles-module--about--LCNnA";
export var content = "styles-module--content--mNVmW";
export var description = "styles-module--description--ujFEU";
export var email = "styles-module--email--d+k4n";
export var header = "styles-module--header--AaiAX";
export var menu = "styles-module--menu--u+rQE";
export var name = "styles-module--name--OOAem";
export var profilePhoto = "styles-module--profile-photo--pqczn";